import React from "react";
import Card from "components/card";
import LineChartBase from "components/charts/LineChartBase";

const data = [
    { month: "May", score: 0 },
    { month: "Jun", score: 0 },
    { month: "Jul", score: 0 },
    { month: "Aug", score: 0 },
    { month: "Sep", score: 0 },
    { month: "Oct", score: 0 },
];

const PerformanceTrend = () => {
    return (
        <Card className="text-slate-900 flex flex-col gap-6 rounded-xl border border-slate-200 bg-white dark-mode-card">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 pb-3">
                <h4 className="text-[16px] title-text">
                    Performance Trend
                </h4>
                <p className="text-slate-700 text-[11px] dark:text-slate-200">
                    Monthly performance scores
                </p>
            </div>
            <div className="px-6 pb-6 pt-2">
                <LineChartBase 
                    data={data} 
                    xKey="month" 
                    yKey="score" 
                />
            </div>
        </Card>
    );
};

export default PerformanceTrend;
